// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"7eec1a5f","56":"4da7e6d1","232":"089c3f3b","300":"dff2fb4d","320":"21e2d016","416":"2e99ba20","509":"fe8d28c8","808":"d627e2f4","840":"e2b2c998","856":"7fbd6668","940":"4b4dfaf3","952":"492faef7"}[chunkId] + ".chunk.js";
};